import _extends from '@babel/runtime/helpers/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import 'react';
import PropTypes from 'prop-types';
import NavigationButtonsLayoutContainer$1 from '../../Layouts/NavigationButtonsLayoutContainer.js';
import { jsx } from '@emotion/react';
var _excluded = ["children"];
var NavigationButtonsLayoutContainer = function NavigationButtonsLayoutContainer(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  return jsx(NavigationButtonsLayoutContainer$1, _extends({
    px: 4,
    mb: 4
  }, props), children);
};
NavigationButtonsLayoutContainer.propTypes = {
  children: PropTypes.node
};
NavigationButtonsLayoutContainer.defaultProps = {
  children: null
};
export { NavigationButtonsLayoutContainer as default };